import React, { useState } from "react";
import Button from "@mui/material/Button";
import { CarPathContainer } from "commonComponents/SideNav/subSectionNav/Map/MapStyled";
import { Checkbox } from "@mui/material";
import { useEffect } from "react";
import { StyledCheckbox } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { PopUpContainer } from "assets/css/globle";
import { useNavigate } from "react-router-dom";
import { Loader } from "commonComponents/Loader/Loader";

import {
  SITEID_GLOBAL_STATE,
  MAP_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  SiteSetupAction,
  COP_GLOBAL_STATES,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import CloseIcon from "../../../../assets/svgIcons/CloseIcon";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { deepClone } from "../../../../pages/Map/functions/deepClone";
import { isUserReadOnly } from "constant";

export const CarPathSection = () => {
  const { t } = useTranslation();
  
  const [localCpoData] = useState([]);
  const [checkedAllCarPaths, setCheckedAllCarPaths] = useState(true);
  const [uncheckedAllCarPaths, setUncheckedAllCarPaths] = useState(false);
  const [isSaveCpoButtonActive, setIsSaveCpoButtonActive] = useState(false);
  const [optionsCPODataOriginalData, setOptionsCPODataOriginalData] = useState([]);
  const [saving, setSaving] = useState(false);
  const [closeCarPath, setCloseCarPath] = useState(true);
  const [noCPOPopup, setNoCPOPopup] = useState(false);

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const {
    mapSideNavTabState,
    messageActionZone,
    controlsActionZone,
    cartPathActionZone,
    geofenceActionZone,
    shouldInitCpoData,
    cpoData,
    optionsCPOShowCourses,
    actionZoneModified,
    polygonSelectedForCpo,
    shouldCallCpoSelected,
    setCPOColor,
    shouldSetCpoColor,
    optionsCPOData
  } = useHookstate(MAP_GLOBAL_STATES);

  const {
    showAreas,
    showCenterOfGreens,
    showTeeMarkers,
    showPointsOfInterest,
  } = useHookstate(SiteSetupAction);

  const {
    openSaveChangesModal,
    carPathUnSavedChanges,
    nextSubTabIndex,
    nextMainTabIndex,
    nextMainTabName,
  } = useHookstate(COP_GLOBAL_STATES);

  const { subNavDataState } = useHookstate(SIDENAV_GLOBAL_STATE);

  const dispatch = useDispatch();

  const { siteSettingsData, getCarPathActionZone, getUserRole } = useSelector((state) => state.commonReducers) || [];

  const navigate = useNavigate();

  useEffect(() => {
    // Actionzone removing
    messageActionZone.set(false);
    controlsActionZone.set(false);
    cartPathActionZone.set(true);
    geofenceActionZone.set(false);

    //Site setup items removing
    showAreas.set(false);
    showCenterOfGreens.set(false);
    showTeeMarkers.set(false);
    showPointsOfInterest.set(false);

    carPathUnSavedChanges.set(false);
  }, []);

  useEffect(() => {
    if(shouldInitCpoData.get() && siteSettingsData?.Courses && optionsCPOData?.get() === null && getCarPathActionZone.length > 0) {
      initCpoData();
    }
  }, [shouldInitCpoData.get(), siteSettingsData?.Courses, getCarPathActionZone, siteId.get()]);

  //Handles logic coming from actionZoneSelected function on MapComponents if user has clicked on CPO tab
  useEffect(() => {
    // find this hole in the CPO data array
    if(polygonSelectedForCpo.get() != null) {
      for (var i = 0; i < optionsCPOData?.get()?.length; i++) {
        if (optionsCPOData?.get()[i].Number === polygonSelectedForCpo.get().actionZoneInfo.Course) {
          for (var j = 0; j < optionsCPOData?.get()[i].Holes.length; j++) {
              if (optionsCPOData?.get()[i].Holes[j].Hole === polygonSelectedForCpo.get().actionZoneInfo.Hole) {
                // select this course
                selectCourse(optionsCPOData?.get()[i]);
                // toggle the action zones for this course and hole
                toggleHole(optionsCPOData?.get()[i], optionsCPOData?.get()[i].Holes[j]);
                // only toggle once
                break;
              }
          }
        }
      }

      polygonSelectedForCpo.set(null);
    }
  }, [shouldCallCpoSelected.get()]);

  const alertPopupStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "calc(100% - 40px)",
    bgcolor: "#fff",
    borderRadius: "5px",
    overflow: "hidden",
  };

  async function initCpoData() {
    let localOptionsCPOData = [];
    optionsCPOShowCourses.set(false);

    // get the course data required for CPO AZs
    for (var i = 0; i < siteSettingsData?.Courses?.length; i++) {
      var cpoCourse = {
        Number: siteSettingsData.Courses[i].Number,
        Name: siteSettingsData.Courses[i].Name,
        HoleCount: siteSettingsData.Courses[i].HoleCount,
        Holes: []
      };

      for (var y = 0; y < cpoCourse.HoleCount; y++) {
          let cpoHole = {
            Course: cpoCourse.Number,
            Hole: y + 1,
            ZoneExists: false,
            IsEnabled: false
          };

          cpoCourse.Holes.push(cpoHole);
      }

      localOptionsCPOData.push(cpoCourse);
    }

    // set the multiple courses flag
    if (siteSettingsData?.Courses?.length > 1) {
      optionsCPOShowCourses.set(true);
    }

    // set the first CPO course to visible
    if (localOptionsCPOData.length > 0) {
      localOptionsCPOData[0].IsSelected = true;
    }

    // Set the CPO flags
    for (i = 0; i < getCarPathActionZone.length; i++) {
      if (getCarPathActionZone[i].Hole > 0) {
        localOptionsCPOData[getCarPathActionZone[i].Course - 1].Holes[getCarPathActionZone[i].Hole - 1].ZoneExists = true;
        localOptionsCPOData[getCarPathActionZone[i].Course - 1].Holes[getCarPathActionZone[i].Hole - 1].IsEnabled = getCarPathActionZone[i].IsEnabled;
      }
    }

    //Set Enable All Parent and Children
    for (var i = 0; i < localOptionsCPOData.length; i++) {
      let isExistentZonesEnabled = localOptionsCPOData[i].Holes.filter(x => x.ZoneExists === true).every(x => x.IsEnabled === true);

      localOptionsCPOData[i].IsSelected = isExistentZonesEnabled;
    }

    shouldCheckEnableAllParent(localOptionsCPOData);

    optionsCPOData.set(localOptionsCPOData);
    setOptionsCPODataOriginalData(localOptionsCPOData);   
    actionZoneModified.set(false);
  }

  const selectCourse = (course) => {
    let localOptionsCPOData = deepClone(optionsCPOData?.get());
    
    for (var i = 0; i < localOptionsCPOData.length; i++) {
      localOptionsCPOData[i].IsSelected = false;
    }

    localOptionsCPOData.find(x => x.Number === course.Number).IsSelected = true;

    optionsCPOData.set([...localOptionsCPOData]);
  }

  function handleEnableDisableAllParent(e) {
     if (e.target.name === "enable") {
      setCheckedAllCarPaths(true);
      setUncheckedAllCarPaths(false);
      enableCPOnly();
    } else {
      setCheckedAllCarPaths(false);
      setUncheckedAllCarPaths(true);
      disableCPOnly();
    }

    if(!carPathUnSavedChanges.get()) {
      setCpoModified();
    }
  }

  const setCpoModified = () => {
    carPathUnSavedChanges.set(true);
    setIsSaveCpoButtonActive(true);
  }

  function handleCpoDataCheck(isChecked, courseNumber) {
    let localOptionsCPOData = deepClone(optionsCPOData?.get());
    let cpoColorToSet = [];

    localOptionsCPOData?.map((item) => {
      if (item.Number === courseNumber) {
        if (isChecked) {
          item.IsSelected = true;
          item.Holes.map((hole) => {
            if (hole.ZoneExists) {
              hole.IsEnabled = true;
              cpoColorToSet.push(...setCPOnly(hole));
            }
          });
        } else {
          item.IsSelected = false;
          item.Holes.map((hole) => {
            hole.IsEnabled = false 
            cpoColorToSet.push(...setCPOnly(hole));
          });
        }
      }
    });
  
    //This is handled on useEffect on MapComponents
    setCPOColor.set(cpoColorToSet);
    shouldSetCpoColor.set(true);

    shouldCheckEnableAllParent(localOptionsCPOData);

    cpoData.set(localCpoData);
    optionsCPOData.set([...localOptionsCPOData]);

    if(!carPathUnSavedChanges.get()) {
      setCpoModified();
    }
  }

  const shouldCheckEnableAllParent = (localOptionsCPOData) => {
    let isAllIsSelected = localOptionsCPOData.every(x => x.IsSelected === true);
    let isAllIsDeselected = localOptionsCPOData.every(x => x.IsSelected === false);

    setCheckedAllCarPaths(isAllIsSelected);
    setUncheckedAllCarPaths(isAllIsDeselected);
  }

  const setCPOnly = (hole) => {
    let cpoColorToSet = [];

    // set cpo for this course and hole
    for (var i = 0; i < getCarPathActionZone.length; i++) {
      if (getCarPathActionZone[i].Hole > 0) {
        if (getCarPathActionZone[i].Course === hole.Course && getCarPathActionZone[i].Hole === hole.Hole) {
          cpoColorToSet.push({Id: getCarPathActionZone[i].Id, Type: getCarPathActionZone[i].Type, IsEnabled: hole.IsEnabled});
          setCPOActionZone(getCarPathActionZone[i].Id, hole.IsEnabled, getCarPathActionZone[i].IsEnabled !== hole.IsEnabled);
        }
      }
    }

    return cpoColorToSet;
  }

  const setCPOActionZone = (Id, IsEnabled, New) => {
    // If the action zone is already in the array, remove the old entry
    for (var i = 0; i < localCpoData.length; i++) {
       if (localCpoData[i].Id === Id) {
        localCpoData.splice(i, 1);
        cpoData.set(localCpoData);
       }
    }
    // If this is a new value add it to the array
    if (New) {
      addCPOHole(Id, IsEnabled);
    }
  }

  const toggleHole = (course, hole) => {
    if (hole?.ZoneExists) {     
      let localOptionsCPOData = deepClone(optionsCPOData.get());
      let cpoColorToSet = [];

      const selectedCourse = localOptionsCPOData.filter(x => x.Number === course.Number);
      const selectedHole = selectedCourse[0].Holes.find(x => x.Course === hole.Course && x.Hole === hole.Hole);

      if(selectedHole) {
        selectedHole.IsEnabled = !hole.IsEnabled;

        optionsCPOData.set([...localOptionsCPOData]);

        cpoColorToSet = setCPOnly(selectedHole);

        //This is handled on useEffect on MapComponents
        setCPOColor.set(cpoColorToSet);
        shouldSetCpoColor.set(true);
      }

      cpoData.set(localCpoData);
    } else {
      setNoCPOPopup(true);
      return;
    }

    if(!carPathUnSavedChanges.get()) {
      setCpoModified();
    }
  } 

  function enableCPOnly() {
    var i;

    // Update the observable array settings
    let localOptionsCPOData = deepClone(optionsCPOData?.get());

    for (i = 0; i < localOptionsCPOData.length; i++) {
      localOptionsCPOData[i].IsSelected = true;
      
      for (var j = 0; j < localOptionsCPOData[i].Holes.length; j++) {
          if (localOptionsCPOData[i].Holes[j].ZoneExists)
          localOptionsCPOData[i].Holes[j].IsEnabled = true;
      }
    }

    optionsCPOData.set(localOptionsCPOData);

    //Enable all CPO action zones that are not already enabled
    cpoData.set([]);

    let cpoColorToSet = [];
    for (i = 0; i < getCarPathActionZone.length; i++) {
      if (getCarPathActionZone[i].Hole > 0) {
        cpoColorToSet.push({Id: getCarPathActionZone[i].Id, Type: getCarPathActionZone[i].Type, IsEnabled: true});

        if (!getCarPathActionZone[i].IsEnabled) {         
          addCPOHole(getCarPathActionZone[i].Id, true);
        }
      }
    }

    //This is handled on useEffect on MapComponents
    setCPOColor.set(cpoColorToSet);
    shouldSetCpoColor.set(true);

    cpoData.set(localCpoData);
  }

  function disableCPOnly() {
    var i;

    // Update the observable array settings
    let localOptionsCPOData = deepClone(optionsCPOData?.get());

    for (i = 0; i < localOptionsCPOData.length; i++) {
      localOptionsCPOData[i].IsSelected = false;

      for (var j = 0; j < localOptionsCPOData[i].Holes.length; j++) {
          if (localOptionsCPOData[i].Holes[j].ZoneExists)
            localOptionsCPOData[i].Holes[j].IsEnabled = false;
      }
    }

    optionsCPOData.set(localOptionsCPOData);

    //Disable all CPO action zones that are not already disabled
    cpoData.set([]);
    let cpoColorToSet = [];

    for (i = 0; i < getCarPathActionZone.length; i++) {
      if (getCarPathActionZone[i].Hole > 0) {
        cpoColorToSet.push({Id: getCarPathActionZone[i].Id, Type: getCarPathActionZone[i].Type, IsEnabled: false});
        if (getCarPathActionZone[i].IsEnabled) {
          addCPOHole(getCarPathActionZone[i].Id, false);
        }
      }
    }

    //This is handled on useEffect on MapComponents
    setCPOColor.set(cpoColorToSet);
    shouldSetCpoColor.set(true);

    cpoData.set(localCpoData);
  }

  const addCPOHole = (Id, IsEnabled) => {
    var hs = {
      Id: Id,
      IsEnabled: IsEnabled
    };

    localCpoData.push(hs);
 }

  async function handleSaveCpo() {
    setSaving(true);

    const cpoDataList = Object.keys(cpoData.get())?.map(key => {
      const obj = cpoData.get()[key];
      return { ...obj };
    });

    dispatch(COMMON_SERVICES.putCpoSettingsService(siteId.get(), cpoDataList)).then(() => {
      setSaving(false);

      mapSideNavTabState.set("");
      cartPathActionZone.set(false);
      carPathUnSavedChanges.set(false);
      setIsSaveCpoButtonActive(false);
  
      resetCpo();
    });
  }

  const handleCancel = () => {
    if (JSON.stringify({...optionsCPOData?.get()}) !== JSON.stringify(optionsCPODataOriginalData)) {
      openSaveChangesModal.set(true);
      setCpoModified();
    }
    else {
      subNavDataState.set("");
      carPathUnSavedChanges.set(false);
      setIsSaveCpoButtonActive(false);
    }
  };

  const discardChangesYesFunction = () => {
    if (nextMainTabIndex.get()) {
      navigate(`/${nextMainTabName.get().toLowerCase()}`);
      nextMainTabIndex.set("");
    } else if (nextSubTabIndex.get()) {
      if (nextSubTabIndex.get() !== "CPO") {
        setIsSaveCpoButtonActive(false);
        localStorage.setItem("activeMapSideNavTab", nextSubTabIndex.get());
        localStorage.setItem("mapSideNavTabState", nextSubTabIndex.get());
        mapSideNavTabState.set(nextSubTabIndex.get());
      } else {
        mapSideNavTabState.set("");
        cartPathActionZone.set(false);
      }
    } else {
      mapSideNavTabState.set("");
      subNavDataState.set("");
      cartPathActionZone.set(false);
    }
    carPathUnSavedChanges.set(false);
    openSaveChangesModal.set(false);

    resetCpo();
  };

  const resetCpo = () => {
    cpoData.set(null);
    shouldInitCpoData.set(false);
    optionsCPOData.set(null);
  }

  return (
    <>
      {saving &&
        <>
          <div className="loading-center">{t("Saving..")}</div>
          <Loader />
        </>
      }

      {!saving &&
        <CarPathContainer className="cart-path-container">
          {closeCarPath && (
            <>
              <div className="close-icon-wrapper-mobile">
                <button
                  onClick={() => {
                    if (carPathUnSavedChanges.get()) {
                      openSaveChangesModal.set(true);
                      nextSubTabIndex.set("");
                    } else {
                      setCloseCarPath(false);
                    }
                  }}
                >
                  <CloseIcon />
                </button>
              </div>
              <div className="page-heading">{t("Todays_Cart_Path_Rule")}</div>
              <div className="disable-checkbox-section">
                <StyledCheckbox>
                  <Checkbox
                    label={t("Enable_All")}
                    name="enable"
                    checked={checkedAllCarPaths}
                    onChange={handleEnableDisableAllParent}
                  />
                  <span>{t("Enable_All")}</span>
                </StyledCheckbox>
                <StyledCheckbox>
                  <Checkbox
                    label={t("Disable_All")}
                    name="disable"
                    checked={uncheckedAllCarPaths}
                    onChange={handleEnableDisableAllParent}
                  />
                  <span>{t("Disable_All")}</span>
                </StyledCheckbox>
              </div>
              {optionsCPOData.get() != null && Object.entries(optionsCPOData.get())?.map((c, i) => {
                c = c[1];

                  return (
                    <div className="circle-section" key={`${c.Name}_${i}`}>
                      <div className="heading">
                        <h5>{c?.Name}</h5>

                        <StyledCheckbox>
                          <Checkbox
                            label="Enable A"
                            checked={c.IsSelected}
                            name={c.Name}
                            onChange={(e) => handleCpoDataCheck(e.target.checked, c.Number)}
                          />
                          <span>{t("Enable_All")}</span>
                        </StyledCheckbox>
                      </div>
                      <div className="circle-wrapper">
                        {c?.Holes.map((h) => {
                          return (
                            <button
                              key={h.Hole}
                              className={h.IsEnabled ? "active" : "deactive"}
                              onClick={() => {
                                toggleHole(c, h);
                              }}
                            >
                              {h.Hole}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              <div className="action-wrapper">
                <Button
                  variant="outlined"
                  className={isSaveCpoButtonActive && !isUserReadOnly(getUserRole && getUserRole?.Role) ? "active" : "disabled"}
                  onClick={handleSaveCpo}
                >
                  {t("Save")}
                </Button>

                <Button
                  variant="outlined"
                  className="send-btn"
                  onClick={handleCancel}
                >
                  {t("Cancel")}
                </Button>
              </div>{" "}
            </>
          )}
        </CarPathContainer>
      }
      <Modal
        open={openSaveChangesModal.get()}
        onClose={() => openSaveChangesModal.set(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={alertPopupStyle}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p> {t("Discard_changes")} ? </p>
            <div className="action-btn">
              <button
                onClick={() => {
                  discardChangesYesFunction();
                }}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button
                onClick={() => {
                  openSaveChangesModal.set(false);
                }}
              >
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>

      <Modal
        open={noCPOPopup}
        onClose={() => setNoCPOPopup(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={alertPopupStyle}>
          <PopUpContainer className="py-30">
            <h2>Visage</h2>
            <p>
              {t(
                "No_Cart-path_Only_Action_Zones_have_been_assigned_to_this_hole"
              )}
            </p>
            <div className="action-btn">
              <button className="primary" onClick={() => setNoCPOPopup(false)}>
                {t("Ok")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </>
  );
};
